// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
angular.module('FeedbackApp', ['giCarousel', 'giRemoting']);

$('.site_help a').on('click', function (e) {
  e.preventDefault();
  return window.open($(this).attr('href'), 'Popup', 'height=670, width=670');
});
